import { createUseStyles } from 'react-jss';
import { BannerProps } from '.';
import { Classes } from 'jss';
import { StatusVariant, PRIMARY_STATUS_COLORS } from '@tcl-argon-utils/utils';
import { GrayscalePalette, BrandPalette } from '@tcl-boron-colors/colors';

export const useBannerStyles: (
  data?: BannerProps & {
    status?: StatusVariant;
  },
) => Classes<'content' | 'root' | 'icon'> = createUseStyles({
  root: {
    backgroundColor: ({ status }: BannerProps) =>
      status === 'warning' || status === 'success' || status === 'error'
        ? PRIMARY_STATUS_COLORS[status]
        : GrayscalePalette[100],
    boxShadow: overrideCardShadowStyles,
    display: 'flex',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '14px',
    padding: '12px 24px',
    position: 'relative',
    borderRadius: '8px',
  },
  icon: {
    marginRight: '16px',
    color: ({ status }: BannerProps) =>
      status === 'warning' || status === 'success' || status === 'error' ? GrayscalePalette[100] : BrandPalette[700],
  },
  content: {
    display: 'flex',
    color: ({ status }: BannerProps) =>
      status === 'warning' || status === 'success' || status === 'error' ? GrayscalePalette[100] : BrandPalette[700],
  },
});

/**
 * Overrides the inherited Card shadow styles, as
 * colorful banners shouldn't have a shadow
 * @param theme
 */
function overrideCardShadowStyles({ status }: BannerProps) {
  if (status === 'warning' || status === 'success' || status === 'error') {
    return 'none';
  } else {
    return `0px 1px 3px 1px ${GrayscalePalette[300]}`;
  }
}
